"use client";

import { useEffect } from "react";

function applyAriaAttributes(toast: Element) {
  const type = toast.getAttribute("data-type");
  const isUrgent = type === "error" || type === "warning";

  toast.setAttribute("role", isUrgent ? "alert" : "status");
  toast.setAttribute("aria-live", isUrgent ? "assertive" : "polite");
  toast.setAttribute("aria-atomic", "true");

  const icon = toast.querySelector("[data-icon]");
  if (icon) {
    icon.setAttribute("aria-hidden", "true");
  }
}

export function ToastAccessibility() {
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.hasAttribute("data-sonner-toast")) {
            applyAriaAttributes(node);
          }

          for (const toast of node.querySelectorAll("[data-sonner-toast]")) {
            applyAriaAttributes(toast);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Apply to any already-existing toasts
    for (const toast of document.querySelectorAll("[data-sonner-toast]")) {
      applyAriaAttributes(toast);
    }

    return () => observer.disconnect();
  }, []);

  return null;
}
